import React from "react";

const QuranTranslationPopupPanel = ({
  uiLabels,
  translationVerseWords,
  loadedPages,
  loadedFontFamilies,
  uthmanicFont,
  truncateLabel,
  translationLanguageMenuRef,
  translationOptionsLoading,
  translationLanguageMenuOpen,
  setTranslationLanguageMenuOpen,
  translationLanguageOptions,
  translationLanguageCode,
  onSelectTranslationLanguage,
  bookMenuRef,
  bookMenuSuppressUntilRef,
  translationResources,
  bookMenuOpen,
  setBookMenuOpen,
  translationResourceId,
  onSelectTranslationBook,
}) => (
  <>
    {translationVerseWords.length > 0 && (
      <div className="quran-popup-verse-wrap" dir="rtl" aria-label={uiLabels.verseArabic}>
        <div className="quran-popup-verse-line">
          {translationVerseWords.map((word) => {
            const pageNumber = Number(word.pageNumber);
            const family = `p${pageNumber}-v2`;
            const useGlyph = loadedPages.has(pageNumber) || loadedFontFamilies.has(family);

            return (
              <span
                key={`popup-${word.verseKey}-${word.position}-${word.id}`}
                style={{ fontFamily: useGlyph && word.codeV2 ? family : uthmanicFont }}
                dangerouslySetInnerHTML={{ __html: useGlyph ? word.codeV2 : word.textQpcHafs }}
                className={`quran-popup-verse-word ${word.charTypeName === "end" ? "quran-end-marker" : ""}`}
              />
            );
          })}
        </div>
      </div>
    )}

    <div className="quran-translation-controls">
      <label className="quran-translation-control">
        <span>{uiLabels.language}</span>
        <div className="quran-book-select" ref={translationLanguageMenuRef}>
          <button
            type="button"
            className="quran-book-trigger"
            onClick={(event) => {
              event.stopPropagation();
              setTranslationLanguageMenuOpen((prev) => !prev);
            }}
            disabled={translationOptionsLoading}
            aria-expanded={translationLanguageMenuOpen}
          >
            <span>
              {truncateLabel(
                translationLanguageOptions.find((lang) => lang.code === translationLanguageCode)
                  ? `${
                      translationLanguageOptions.find((lang) => lang.code === translationLanguageCode)
                        ?.nativeName ||
                      translationLanguageOptions.find((lang) => lang.code === translationLanguageCode)?.name
                    } (${translationLanguageCode})`
                  : translationLanguageCode.toUpperCase(),
                34
              )}
            </span>
            <span className="quran-book-caret">▾</span>
          </button>

          {translationLanguageMenuOpen && (
            <div className="quran-book-menu" role="listbox" onClick={(event) => event.stopPropagation()}>
              {translationLanguageOptions.map((lang) => (
                <button
                  type="button"
                  key={`lang-${lang.code}`}
                  className={`quran-book-option ${
                    lang.code === translationLanguageCode ? "quran-book-option--active" : ""
                  }`}
                  onClick={(event) => {
                    event.stopPropagation();
                    onSelectTranslationLanguage(lang.code);
                  }}
                  title={lang.nativeName ? `${lang.nativeName} (${lang.code})` : `${lang.name} (${lang.code})`}
                >
                  {truncateLabel(
                    lang.nativeName ? `${lang.nativeName} (${lang.code})` : `${lang.name} (${lang.code})`,
                    34
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </label>

      <label className="quran-translation-control">
        <span>{uiLabels.book}</span>
        <div className="quran-book-select" ref={bookMenuRef}>
          <button
            type="button"
            className="quran-book-trigger"
            onClick={(event) => {
              event.stopPropagation();
              if (Date.now() < bookMenuSuppressUntilRef.current) {
                return;
              }
              setBookMenuOpen((prev) => !prev);
            }}
            disabled={translationOptionsLoading || translationResources.length === 0}
            aria-expanded={bookMenuOpen}
          >
            <span>
              {truncateLabel(
                translationResources.find((resource) => resource.id === translationResourceId)?.book ||
                  (translationResources.length === 0 ? uiLabels.noBook : uiLabels.chooseBook)
              )}
            </span>
            <span className="quran-book-caret">▾</span>
          </button>

          {bookMenuOpen && translationResources.length > 0 && (
            <div className="quran-book-menu" role="listbox" onClick={(event) => event.stopPropagation()}>
              {translationResources.map((resource) => (
                <button
                  type="button"
                  key={resource.id}
                  className={`quran-book-option ${
                    resource.id === translationResourceId ? "quran-book-option--active" : ""
                  }`}
                  onClick={(event) => {
                    event.stopPropagation();
                    onSelectTranslationBook(resource.id);
                  }}
                  title={resource.book || `Resource ${resource.id}`}
                >
                  {truncateLabel(resource.book || `Resource ${resource.id}`, 32)}
                </button>
              ))}
            </div>
          )}
        </div>
      </label>
    </div>
  </>
);

export default QuranTranslationPopupPanel;